import AppointmentModal from "../modal/AppointmentModal";
import {useState} from "react";

export default function DoctorCard({doctor, isVisible, setIsVisible, setDocData}) {
    // const [isVisible, setIsVisible] = useState(false)
    return (
        <>

            <div className="doctor-card" >
                <div className="doctor-card__header">
                    <img src={doctor.image} alt="Doctor Image"/>
                    <h2 className="title">{doctor.name}</h2>
                </div>
                <div className="doctor-card__body">
                    <p>{doctor.description}</p>
                </div>
                <div className="doctor-card__footer">
                    <button className='btn-appointment' onClick={() => {
                        setDocData(doctor);
                        setIsVisible(!isVisible)
                    }}>Book Appointment
                    </button>
                </div>
            </div>
        </>
    )
}



